import { useState } from "react";
import { unlockBooth } from "../services/api";

export function useUnlockSession() {
	const [unlocking, setUnlocking] = useState(false);
	const [error, setError] = useState(null);

	const unlock = async (userId, boothId) => {
		if (!userId || !boothId) {
			throw new Error("User ID and booth ID are required");
		}

		setUnlocking(true);
		setError(null);

		try {
			const result = await unlockBooth(userId, boothId);
			return result;
		} catch (err) {
			setError(err.message);
			throw err;
		} finally {
			setUnlocking(false);
		}
	};

	const clearError = () => setError(null);

	return {
		unlock,
		unlocking,
		error,
		clearError,
	};
}